(($, Drupal, drupalSettings) => {
  Drupal.behaviors.userPopups = {
    attach: (context, settings) => {
      if ((document.body.classList.contains('page-node-type-professionals-listing')) || document.body.classList.contains('page-node-type-office')) {
        // $(context.querySelectorAll('.profile.profile--view-mode-listing-card')).once('user-popups').each( (index,item) => {
        $(once('user-popups', '.profile.profile--view-mode-listing-card')).each( (index,item) => {
          item.style.cursor = 'pointer';
          item.addEventListener('click', e => {
            if (e.target.tagName == 'A' && !e.target.classList.contains('name')) {

            }
            else {
              e.preventDefault();
              Drupal.ajax({
                url: drupalSettings.path.baseUrl + drupalSettings.path.pathPrefix + 'user-card/' + item.dataset.profileUuid,
              }).execute();
            }

          })
        });
      }
      // $(context.querySelectorAll('.listing-card-offices')).once('add-listeners').each( (index,item) => {
      $(once('add-listeners', '.listing-card-offices')).each( (index,item) => {
        var trigger = item.querySelector('a.show-listing-card-offices');
        if(trigger != null) {
          trigger.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            var div = item.querySelector('.hide-offices');
            div.style.display = div.style.display === 'none' ? 'block' : 'none';
          });
        }
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
